import {createProductStore, Store} from "@/app/lib/pricing/paddle-store";

const paddleTestStore: Store = createProductStore({
    testMode: true,
    productId: 'pro_01jafj2sb2z9ckpsx1wqr6mshq',
    foundationMonthlyPriceId: 'pri_01jafj5fatmwskasc2835h930d',
    foundationPlusMonthlyPriceId: 'pri_01jafjeyra1q61k2xb3mbp09na',
    foundationYearlyPriceId: 'pri_01jafj92fh1frcednj5sng2zr2',
    foundationPlusYearlyPriceId: 'pri_01jafjg6vbwk9achhc59eqpgke',
    proMonthlyPriceId: 'pri_01jafjb48t56nsct851qv0b77b',
    proPlusMonthlyPriceId: 'pri_01jafjhax8sv3c4366vks6tkqs',
    proYearlyPriceId: 'pri_01jafjdj2tvz8g3qv0xdc6ph1b',
    proPlusYearlyPriceId: 'pri_01jafjjc582ps041p0y55parb8',
});

export default paddleTestStore;
